module.exports = __webpack_public_path__ + "img/cape-verde.1659906a.png";